import React from 'react'
import { CheckinIcon } from './styles'

const AwaitingFeedbackMarker = ({ isActivityCourse }) => (
  <div
    style={{
      height: '32px',
      width: '32px',
      border: '1px solid transparent',
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      bottom: '0',
      zIndex: 2,
      borderRadius: '50%',
      overflow: 'hidden'
    }}
  >
    <CheckinIcon isActivityCourse={isActivityCourse} />
  </div>
)

export default AwaitingFeedbackMarker
